import { Input, Form, Row, Col } from "antd";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { isAuthenticated } from "../../../commons/Auth/auth";
import MainButtonComp from "../../../commons/Buttons/MainButtonComp";
import DragUpload from "../../../commons/DragUpload/DragUpload";
import { Error, Success } from "../../../commons/Messages/Messages";
import { SocketContext } from "../../../context/SocketContext";
import "./Clients.css";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";
import GeneralModal from "../General.modal";
import { useTranslation } from "react-i18next";
import UploadImageNew from "../../../commons/UploadImage/UploadImageNew";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";

const UpdateClient = ({ data, updateParent }) => {
  const { t } = useTranslation("dashboard");
  const [form] = Form.useForm();
  const socket = useContext(SocketContext);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (data) {
      form.setFieldsValue(data);
      if (data.image?.url) {
        setImagePreview(data.image.url);
      }
    }
  }, [data, form]);

  const onFinish = async values => {
    setLoading(true);
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/users/update-profile/${data?._id}`,
        values,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      );
      setLoading(false);
      if (res.status === 200 || res.status === 304) {
        Success(res.data.successMessage);
        handleCancel();
        updateParent();
        socket.emit("refresh service provider data", {
          user: isAuthenticated()?.serviceProviderId
        });
      } else {
        Error(res.data.errorMessage);
      }
    } catch (err) {
      setLoading(false);
      generalErrorAlert(err);
    }
  };

  const uploadButton = (
    <button className="upload-btn" type="button">
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div className="mt-2">{t("Upload pic")}</div>
    </button>
  );

  const items = (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <Row gutter={[16, 0]}>
        <Col xs={24}>
          <Form.Item label={t("Image")}>
            {imagePreview && (
              <img
                src={imagePreview}
                alt={t("User")}
                style={{ objectFit: "cover" }}
                width="100"
                height="100"
                className="rounded-circle"
              />
            )}
            <Form.Item name="image" valuePropName="fileList" getValueFromEvent={e => e}>
              <UploadImageNew name="image" listType="picture-circle" maxCount={1}>
                {data?.image?.url ? (
                  <img
                    className="rounded-circle"
                    src={data?.image?.url}
                    alt={t("User")}
                    style={{ width: "100%", objectFit: "cover" }}
                  />
                ) : (
                  uploadButton
                )}
              </UploadImageNew>
            </Form.Item>
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item
            name="firstName"
            label={t("First Name")}
            rules={[{ required: true, message: t("enter", { field: t("First Name") }) }]}
          >
            <Input placeholder={t("enter", { field: t("First Name") })} />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item
            name="lastName"
            label={t("Last Name")}
            rules={[{ required: true, message: t("enter", { field: t("Last Name") }) }]}
          >
            <Input placeholder={t("enter", { field: t("Last Name") })} />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item name="username" label={t("Username")}>
            <Input placeholder={t("enter", { field: t("Username") })} />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item
            name="email"
            label={t("Email")}
            rules={[
              // { required: true, message: t("enter", { field: t("Email") }) },
              { type: "email", message: t("Please enter a valid email") }
            ]}
          >
            <Input type="email" placeholder={t("enter", { field: t("Email") })} />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item
            name="clientId"
            label={t("Client ID")}
            rules={[{ required: true, message: t("enter", { field: t("Client ID") }) }]}
          >
            <Input placeholder={t("enter", { field: t("Client ID") })} />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item name="phone" label={t("Phone")}>
            <Input type="number" placeholder={t("enter", { field: t("Phone") })} />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item name="address" label={t("Address")}>
            <Input placeholder={t("enter", { field: t("Address") })} />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item name="city" label={t("City")}>
            <Input placeholder={t("enter", { field: t("City") })} />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item name="state" label={t("State")}>
            <Input placeholder={t("enter", { field: t("State") })} />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item name="country" label={t("Country")}>
            <Input placeholder={t("enter", { field: t("Country") })} />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item name="zipCode" label={t("Zip Code")}>
            <Input placeholder={t("enter", { field: t("Zip Code") })} />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item name="company" label={t("Company Name")}>
            <Input placeholder={t("enter", { field: t("Company Name") })} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );

  const onChangetab = key => {};

  return (
    <div className="UpdateClient">
      <MainButtonComp text="Edit" editBtn onClick={showModal} />
      <GeneralModal
        title={t("Update Client")}
        onOk={() => form.submit()}
        open={isModalOpen}
        okText={t("Save")}
        onCancel={handleCancel}
        onChange={onChangetab}
        items={items}
      />
    </div>
  );
};

export default UpdateClient;
